export default "__VITE_ASSET__62b2aace__"